import styled from 'styled-components';
import { palette } from 'styled-tools';

import { fontSize, FontSizes, fontWeight, FontWeights, TextButton, units } from '@calm-web/design-system';

export const SearchSuggestionsContainer = styled.div``;

export const SearchSuggestionsList = styled.ul`
	list-style: none;
	padding: 0;
`;

export const SearchSuggestionsListItem = styled.li``;

export const SearchSuggestionsListItemButton = styled(TextButton)`
	color: ${palette('adaptiveText', 'white')};
	${fontSize(FontSizes.base)};
	${fontWeight(FontWeights.Medium)};
	margin-bottom: ${units(1.5)};
	line-height: 133%;
	text-decoration: none;
`;
